import React, { useContext, useEffect } from 'react';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import GlobalStyled from '../../AcessoExlusivo.style';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import OverviewExclusivo from '../components/OverviewExclusivo';
import CicloExclusivo from '../components/CicloExclusivo';
import gestaoLogo from './../../../../images/solutions/logo/gestaoLogo.png';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import { ListMateriasGestaoPlanoAnual } from './ListMateriaisGestao';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const GestaoPrivate = () => {
    const { loading, idsMyCategorias } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <GlobalStyled.GlobalContainer isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [3, 4, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                : ''
                        }
                        title="Gestão Nota 10"
                        img="ExclusivoGestaoImagem1.jpg"
                        logo={gestaoLogo}
                        arquivo={'GN10_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/GN10_Documento_Geral.pdf'}
                        nome_arquivo="Gestao_Visao_Geral"
                        description={`
                            O Gestão Nota 10 tem como objetivo promover o desenvolvimento de uma política educacional democrática e inclusiva a partir da construção de uma rede
                            integrada de escolas autônomas, que garantam o ingresso, a permanência e o sucesso dos alunos, geridas por diretores tecnicamente competentes e capacitados
                            a garantirem o alcance das metas de qualidade da aprendizagem dos alunos e melhoria dos indicadores educacionais. </br> </br>
                            Acesse o documento de visão geral para saber mais.
                        `}
                        regua={
                            [3, 4, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                                : ''
                        }
                    />
                    <CicloExclusivo
                        title="Curso Gestão Nota 10"
                        description={`
                                              O curso Gestão Nota 10 apresenta os conteúdos da solução educacional de modo que os profissionais 
                                              (professores, coordenadores pedagógicos, diretores e/ou técnicos da rede pública de ensino) se apropriem dos conteúdos essenciais para a implementação da proposta.
                                              <br/> <br/>
                                              Inicie agora o curso!
                                            `}
                        img="ExclusivoGestaoImagem2.jpg"
                        itens={
                            [9, 11, 13, 18, 19, 21, 22].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? [
                                      {
                                          title: 'Conhecendo o GN10',
                                          url: '/cursos/gestao-nota10/conhecendo-o-gn10?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 1',
                                          url: '/cursos/gestao-nota10/gn10_modulo1?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 2',
                                          url: '/cursos/gestao-nota10/gn10_modulo2?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 3',
                                          url: '/cursos/gestao-nota10/gn10_modulo3?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 4',
                                          url: '/cursos/gestao-nota10/gn10_modulo4?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 5',
                                          url: '/cursos/gestao-nota10/gn10_modulo5?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 1',
                                          url: '/cursos/gestao-nota10/gn10-foco1?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 2',
                                          url: '/cursos/gestao-nota10/gn10-foco2?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 3',
                                          url: '/cursos/gestao-nota10/gn10-foco3?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 4',
                                          url: '/cursos/gestao-nota10/gn10-foco4?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 5',
                                          url: '/cursos/gestao-nota10/gn10-foco5?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'Aprenda a usar a Farol',
                                          url: '/cursos/farol/farol-gn10?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                  ]
                                : [
                                      {
                                          title: 'Conhecendo o GN10',
                                          url: '/cursos/gestao-nota10/conhecendo-o-gn10?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 1',
                                          url: '/cursos/gestao-nota10/gn10_modulo1?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 2',
                                          url: '/cursos/gestao-nota10/gn10_modulo2?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 3',
                                          url: '/cursos/gestao-nota10/gn10_modulo3?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 4',
                                          url: '/cursos/gestao-nota10/gn10_modulo4?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - Curso 5',
                                          url: '/cursos/gestao-nota10/gn10_modulo5?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 1',
                                          url: '/cursos/gestao-nota10/gn10-foco1?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 2',
                                          url: '/cursos/gestao-nota10/gn10-foco2?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 3',
                                          url: '/cursos/gestao-nota10/gn10-foco3?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 4',
                                          url: '/cursos/gestao-nota10/gn10-foco4?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                      {
                                          title: 'GN10 - FoCo 5',
                                          url: '/cursos/gestao-nota10/gn10-foco5?redirect=exclusivo/gestao-nota-10',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                  ]
                        }
                    />
                    <MateriaisExclusivos
                        title="Materiais especiais para download"
                        description={`  Tenha acesso aos materiais exclusivos do Gestão Nota 10, conheça um pouco mais sobre a solução e comece a traçar os próximos passos rumo à implementação na rede.`}
                        img={'anexo_storage_files_875991415807150199.jpg_2025-03-31-1743443762050.jpg'}
                        items={ListMateriasGestaoPlanoAnual}
                    />
                    <SessionFerramentaVideo solucaoId={2} />
                    <ContactContainer />
                </>
            )}
        </GlobalStyled.GlobalContainer>
    );
};

export default GestaoPrivate;
